export class CommonEntity {
  CreatedBy: string;
  CreatedDate: Date;
  UpdatedBy: string;
  UpdatedDate: Date;
  SortOrder: number;
  IsTrue: boolean;
  Function: string;
  Flag: string;
  Module: string;
  SqlQuery: string;
  MenuId: number;
  MenuName: string;
  ViewName: string;
  TableName: string;
  LoadAll: number;
  LockReq: number;
  LockType: number;
  Message: string;
  ReturnValue: number;
  EatecEntity: number;
  PrintLableFile: string;
  PrintLablePath: string;
  IsTransaction: boolean;
  BackOrderOk: boolean;
  UserId: number;
  ReqLocakedByMe: number;
  HeadLableFile: string;
  HeadLablePath: string;
  NLabels: string;
  ImageId: number;
  PoMode: number;
  PoNum: number;
}
export interface LoginAuthentication {
  DisabledUserContainer: boolean;
  HideAzureContainer: boolean;
  HideForgotPassword: boolean;
  HideForgotContainer: boolean;
  HideAgilysysAzureContainer: boolean;
}

export interface SystemPrefModel{
  LookupName: string;
  LookupValue : number;
}

export class GetCallPayloadEntity {
  IsMobile: boolean
  FetchAll: boolean
  GetTotalRecCount: boolean
  IsActiveOnly: boolean
  LocationIds: any
  LookupField: string
  SearchText: string
  Skip: number
  Take: number
  orderByColumn: string
  orderByDirection: number
  siteId: number
  totalCount: number
  userId: number
  IsPosted?: boolean
  }
  export class GetCallInvDetailsEntity {
    Take?: number;
    Skip?: number;
    FetchAll?: boolean;
    searchText?: string;
    orderByColumn?: string;
    orderByDirection?: number;
    FromDate?: string;
    ToDate?: string;
    TransTypeId?: any;
    IngredientId?: any;
    LookupField?: string;
    NeedExactValue?: boolean;
    UsageTypeId?: boolean;
    SupplierId?: number;
  }